module.exports = __webpack_public_path__ + "static/media/Error.75fed5a0.svg";